import { render, staticRenderFns } from "./submission-panel-supporter-contacts.vue?vue&type=template&id=71027733&scoped=true&"
import script from "./submission-panel-supporter-contacts.vue?vue&type=script&lang=ts&"
export * from "./submission-panel-supporter-contacts.vue?vue&type=script&lang=ts&"
import style0 from "./submission-panel-supporter-contacts.vue?vue&type=style&index=0&id=71027733&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "71027733",
  null
  
)

export default component.exports